module.exports = __webpack_public_path__ + "images/backgrounds/ocean/medium.c8a238f606e3288c461f.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/ocean/medium.jpg
// module id = qQLJ
// module chunks = 2